import { change, reset } from 'redux-form';

import { INFERENTIAL_STATISTICS as FORM } from '../../names';

export const setObservedCountsDataSet = observedCounts =>
  change(FORM, 'chiSquare.observedCountsDataSet', observedCounts);

export const setExpectedCountValue = (variable, level, value) =>
  change(FORM, `chiSquare.${variable}.${level}`, value);

export const resetChiSquareForm = () => reset(FORM);

